"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PersonHierarchyUtil_1 = __importDefault(require("./PersonHierarchyUtil"));
var PositionHierarchyUtil = /** @class */ (function (_super) {
    __extends(PositionHierarchyUtil, _super);
    function PositionHierarchyUtil() {
        var _this = _super.call(this) || this;
        _this.canViewNodeName = true;
        _this.labels = {
            breakdownNameLabel: 'Direct Report Breakdown',
            nodeNameLabel: 'Title',
            nodeExternalIdLabel: 'Position Id',
            nodeDataExternalIdLabel: 'Employee Id',
            nodeDataNameLabel: 'Full Name',
            parentNodeDataNameLabel: 'Manager Name',
            childNodeCountLabel: 'Direct Reports',
        };
        _this._openName = 'Open Position';
        return _this;
    }
    PositionHierarchyUtil.prototype.getNodeDisplayName = function (params) {
        var nodeVm = params.nodeVm;
        return this.nodeDisplayName(nodeVm, params.hierarchyEditState, function (personTitle, personName) {
            if (params.fullName) {
                return "".concat(personName, " / ").concat(personTitle || '(blank)');
            }
            return personName;
        });
    };
    return PositionHierarchyUtil;
}(PersonHierarchyUtil_1.default));
exports.default = PositionHierarchyUtil;
